// extracted by mini-css-extract-plugin
export default {"content":"Content-module--content--tvkAk","container":"Content-module--container--+UOoT","narrow":"Content-module--narrow--Qde1Y"};